import { useThemeUI } from 'theme-ui';
import React from 'react';
import loadable from '@loadable/component';
import { List as SparkList } from '@uswitch/spark.list';
import ICONS from '@uswitch/ev-utils/icons';
import withComponentBase from '../../helpers/with-component-base';
import { Type } from '@uswitch/spark.type';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { Fragment as _Fragment } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var ListItem = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "list-item";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },
  importAsync: function importAsync() {
    return import(
    /* webpackChunkName: "list-item" */
    './list-item');
  },
  requireAsync: function requireAsync(props) {
    var _this = this;

    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./list-item");
    }

    return eval('require.resolve')("./list-item");
  }
});

var ListItems = function ListItems(_ref) {
  var items = _ref.items,
      variant = _ref.variant;

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  return items.map(function (item, i) {
    return _jsx(ListItem, {
      icon: variant && ICONS[variant] ? ICONS[variant].icon : null,
      iconColor: variant && ICONS[variant] ? ICONS[variant].color || theme.elements.list[variant].color : null,
      children: item
    }, i);
  }, this);
};

var ChildrenWithProps = function ChildrenWithProps(_ref2) {
  var children = _ref2.children,
      listType = _ref2.listType,
      variant = _ref2.variant;
  return React.Children.map(children, function (childComponent) {
    return /*#__PURE__*/React.cloneElement(childComponent, {
      listType: listType,
      variant: variant
    });
  });
};

var List = function List(_ref3) {
  var title = _ref3.title,
      _ref3$items = _ref3.items,
      items = _ref3$items === void 0 ? [] : _ref3$items,
      variant = _ref3.variant,
      children = _ref3.children,
      _ref3$listType = _ref3.listType,
      listType = _ref3$listType === void 0 ? 'bullet' : _ref3$listType;
  var Items = items.length ? ListItems : ChildrenWithProps;
  return _jsxs(_Fragment, {
    children: [title && _jsx(Type.H2, {
      children: title
    }), _jsx(SparkList, {
      sx: {
        display: 'inline-block'
      },
      children: _jsx(Items, {
        items: items,
        variant: variant,
        listType: listType,
        children: children
      })
    })]
  });
};

export default withComponentBase(List, {
  withHeaderFooter: true,
  headerStyles: {
    pb: 20,
    pt: 0
  }
});
//# sourceMappingURL=index.js.map